module.exports = __webpack_public_path__ + "img/icon_map_199_on_001.1d1f096f.png";